import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cnpj'})
export class CnpjPipe implements PipeTransform {
  constructor() { }

  transform(cnpj: string) {
    if (!cnpj) {
      return '';
    }
    cnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]+/g, '');
    return cnpj.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
  }

}
